function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}
module.exports = _functionName;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_functionName.js
// module id = 4085
// module chunks = 168707334958949